import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {App, AppId} from '../../../../../../shared/models/app';
import {Subscription} from 'rxjs';
import {AppsService} from '../../../../../../core/services/apps.service';
import {ActivatedRoute} from '@angular/router';
import {TitleBreadcrumbsChangedAction} from '../../../../../../core/actions/title.actions';
import {AppState} from '../../../../../../app/app.state';
import {Store} from '@ngrx/store';
import {UrlService} from '../../../../../../core/services/url.service';
import {SubnavItem} from '../../../../../components/subnav/subnav.component';
import {ShadeToolsService} from '../../../../../../core/services/shade-tools.service';

@Component({
    template: ``,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export abstract class ChildManageBaseComponent implements OnInit, OnDestroy {
  app: App;
  appId: AppId;

  childApp: App;
  childAppId: AppId;

  private childAppRouteSub: Subscription;
  protected appsSub: Subscription;

  subnavItems: SubnavItem[];


  protected constructor(
    protected appsService: AppsService,
    protected urlService: UrlService,
    protected shadeTools: ShadeToolsService,
    protected route: ActivatedRoute,
    protected store: Store<AppState>,
  ) {
  }

  ngOnInit(): void {
    this.childAppRouteSub = this.route.paramMap.subscribe((params) => {
      this.childAppId = params.get('tenantAppId');
      this.appsService.fetchApp(this.childAppId);
      this.populateSubnav();
    });

    this.appId = this.appsService.currentAppId;
    this.appsService.fetchApp(this.appId);
    this.populateSubnav();

    this.onInit();
  }

  ngOnDestroy() {
    this.childAppRouteSub?.unsubscribe();
    this.appsSub?.unsubscribe();

    this.onDestroy();
  }

  private populateSubnav() {
    this.subnavItems = [
      {
        text: 'Users',
        href: UrlService.makePropManagerManageUnitUsersUrl(this.appId, this.childAppId),
      },
      {
        text: 'Configuration',
        href: UrlService.makePropManagerManageUnitConfigurationUrl(this.appId, this.childAppId),
      },
    ];
  }

  protected updateTitle(appName: string = '', subtitle: string = '') {
    this.store.dispatch(new TitleBreadcrumbsChangedAction(
      [{
        path: UrlService.makePropManagerManageUnitsUrl(this.appId),
        text: 'Property Manager',
      }, {
        path: UrlService.makePropManagerManageUnitsUrl(this.appId),
        text: 'Manage Units',
      }, {
        text: this.childApp.Name,
      }],
    ));
  }

  protected showError() {
    this.shadeTools.errorDialog('Something went wrong. Please try again.');
  }


  protected abstract onInit(): void;

  protected abstract onDestroy(): void;

}
